import { SVGProps } from 'react';

export default function Search(props: Partial<SVGProps<any>>) {
  return (
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
<path d="M21 21L16.66 16.66" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className='stroke-dark dark:stroke-white'/>
<path d="M11 19C15.4183 19 19 15.4183 19 11C19 6.58172 15.4183 3 11 3C6.58172 3 3 6.58172 3 11C3 15.4183 6.58172 19 11 19Z"  strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className='stroke-dark dark:stroke-white'/>
</svg>

  )
}